import { BASE_URL } from "../BaseUrl";
import axios from "axios";

// const token = sessionStorage.getItem("token");
axios.interceptors.request.use(function (config) {
  const token = sessionStorage.getItem("token")
  config.headers.Authorization =  token;

  return config;
});

export const getListeForfaits_allRight = async (emplacement, numero) => {
  return await axios.get(BASE_URL(`clientweballrights/rechercherforfaits/${emplacement}?numero=${numero}`), {});
};

export const getListeForfaits_secure = async (emplacement, numero) => {
  return await axios.get(BASE_URL(`clientweb/rechercherforfaits/${emplacement}?numero=${numero}`), {});
};


export const getForfaitById_allRight = async (id, numero) => {
  return await axios.get(
    BASE_URL(`clientweballrights/rechercherforfaitparid/${id}?numero=${numero}`),
    {}
  );
};

export const getForfaitById_secure = async (id, numero) => {
  return await axios.get(
    BASE_URL(`clientweb/rechercherforfaitparid/${id}?numero=${numero}`),
    {}
  );
};

export const getListeSuggestionForfait_allRight = async (emplacement, id, beneficiaire, master) => {
  return await axios.get(
    BASE_URL(`clientweballrights/rechercherforfaitsparid/${emplacement}/${id}?numero=${beneficiaire}&numeroMaster=${master}`),
    {}
  );
};

export const getListeSuggestionForfait_secure = async (emplacement, id, beneficiaire, master) => {
  return await axios.get(
    BASE_URL(`clientweb/rechercherforfaitsparid/${emplacement}/${id}?numero=${beneficiaire}&numeroMaster=${master}`),
    {}
  );
};

export const getListeForfaitPourOffrir_allRight = async (emplacement, numero) => {
  return await axios.get(
    BASE_URL(`clientweballrights/rechercherforfaits/${emplacement}/${numero}`),
    {}
  );
};

export const getListeForfaitPourOffrir_secure = async (emplacement, numero) => {
  return await axios.get(
    BASE_URL(`clientweb/rechercherforfaits/${emplacement}/${numero}`),
    {}
  );
};



export const paiementForfait_allRight = async (id, typeTransaction, numero) => {
  return await axios.post(
    BASE_URL(`clientweballrights/souscrireauforfait/${id}/${typeTransaction}?numero=${numero}`),
    {}
  );
};

export const paiementForfait_secure = async (id, typeTransaction, numero) => {
  return await axios.post(BASE_URL(`clientweb/souscrireauforfait/${id}/${typeTransaction}?numero=${numero}`), {});
};



export const paiementForfaitPourTier_secure = async (values) => {
  return await axios.post(BASE_URL(`clientweb/souscrirepourtiers`), values);
};